import { useMemo } from "react"
import { resolveWeekStartDay, weekGranularityName } from "~/shared/kpi"
import { useCompanyControllerGetFinancialsQuery } from "~/ui-rtk/api/companyApi"
import useCurrentCompany from "~/ui-rtk/hooks/current-company"

/**
 * The Cube granularity to request for weekly bucketing, resolved from the
 * company's reporting week start day (Financial Settings). Companies on the
 * default Monday get Cube's built-in `week`; others get the custom
 * granularity (e.g. `week_thursday`).
 *
 * Weekly queries must request this name directly. Sending plain `week` also
 * works server-side (cube.js queryRewrite maps it), but then the response
 * row keys and annotations come back under the rewritten name while the
 * client-side pivot still looks for `<dimension>.week` — charts end up with
 * no data.
 */
export default function useWeekGranularity(): string {
  const currentCompany = useCurrentCompany()
  const { data: financials } = useCompanyControllerGetFinancialsQuery(
    { id: currentCompany?.id ?? "" },
    { skip: !currentCompany?.id },
  )

  return useMemo(
    () => weekGranularityName(resolveWeekStartDay(financials)),
    [financials],
  )
}
